import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,Popup,
  Button,Selector,TextArea,ImageUploader,DatePicker,NavBar,Image,List,Picker,Toast,Cascader,Grid
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { RightOutline } from 'antd-mobile-icons'
import ImageCropper from '../UserEdit/ImageCropper'; // 引入封装的裁剪组件
import options from './../../comronent/ProvinceCity.json'
import {
    GetDataDictionarysByCode, GetHotelByPId,GetPlanetInfo,SaveNNFile,SavePlanetInfo,GetSystemMemorys
  } from '../../service/service';
import { environment } from '../../service/baseUrl';

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../FormEdit/index.css'

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            fileList: [],

            visibleXY: false,
            valuePickerXY: "0",
            textPickerXY: "请选择",
            pickerXY: [
                [
                ]
            ],

            visibleDQ: false,
            valuePickerDQ: "0",
            textPickerDQ: "请选择",
            pickerDQ: [
                [
                ]
            ],

            visibleGM: false,
            valuePickerGM: "0",
            textPickerGM: "请选择",
            pickerGM: [
                [
                ]
            ],

            visibleJG: false,
            textJG: "请选择",
            valueJG: [],
            options: options,
            imgName: "",
            userInfo: {},
            planetInfo: {},

            // 裁剪相关状态
            cropVisible: false,
            imageUrl: null, // 原始图片临时 URL
            pendingFile: null, // 待裁剪文件
            loading: false // 新增加载状态
        };
    }



    // 处理裁剪完成后的上传
    handleCropComplete = async (croppedBlob) => {
        const { pendingFile } = this.state;
        if (!croppedBlob || !pendingFile) return;

        // 转换为File对象（保持原文件名和类型）
        const croppedFile = new File(
            [croppedBlob],
            pendingFile.name,
            { type: pendingFile.type || 'image/jpeg' }
        );

        // 关闭弹窗并上传
        this.setState({ cropVisible: false }, async () => {
            const result = await this.handleUpload(croppedFile);
            this.setState({ fileList: [{ url: result.url, file: croppedFile }] });
        });
    };

    // 上传逻辑
    handleUpload = async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('userid', this.state.userInfo.id);
            formData.append('scoureName', "Img");
            formData.append('planetId', this.state.id);

            this.setState({ loading: true });
            const response = await SaveNNFile(formData);
            this.setState({ loading: false });
            if (!response.result) throw new Error('上传失败');

            const imageUrl = `${environment.apiEndpoint}/NNFiles/Img/${response.result}`;
            this.setState({
                imgName: response.result
            })
            return { url: imageUrl };
        } catch (error) {
            console.error('上传失败:', error);
            Toast.show({ icon: 'fail', content: '上传失败' });
            throw error;
        }
    };



    componentDidMount() {
        var that = this;

        GetDataDictionarysByCode("XINGYANG").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map((item, index) => {
                    arry.push({ label: item.displayName, value: item.id })
                })
                that.setState({
                    pickerXY: [arry]
                })
            }
        })

        GetHotelByPId("0").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map((item, index) => {
                    arry.push({ label: item.name, value: item.id })
                })
                that.setState({
                    pickerDQ: [arry]
                })
            }
        })


        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            GetPlanetInfo(id).then(res => {
                if (res.success) {
                    var result = res.result;

                    that.formRef.current.setFieldsValue({
                        Name: res.result.name,
                        FamilyRelationOne: res.result.familyRelationOneId,
                        FamilyRelationTwo: res.result.familyRelationTwoId,
                        Sex: res.result.sex,
                        Ethnicity: res.result.ethnicity,
                        Hometown: res.result.hometown,
                        BeliefId: res.result.beliefId,
                        Hobby: res.result.hobby,
                        Career: res.result.career,
                        Remark: res.result.remark,
                        IsBuried: res.result.isBuried,
                        AreaId: res.result.areaId,
                        CemeteryId: res.result.cemeteryId,
                        CemeteryNum: res.result.cemeteryNum,
                        Birthday: new Date(res.result.birthday),
                        DeadDate: new Date(res.result.deadDate),
                    })

                    setTimeout(() => {
                        var item1 = that.state.pickerXY[0].filter(x => x.value == result.beliefId);
                        var item2 = that.state.pickerDQ[0].filter(x => x.value == result.areaId);
                        that.setState({
                            valuePickerXY: result.beliefId,
                            textPickerXY: item1[0] == null ? "请选择" : item1[0].label,

                            valuePickerDQ: result.areaId,
                            textPickerDQ: item2[0] == null ? "请选择" : item2[0].label
                        })

                        if (result.areaId != null && result.areaId != 0) {
                            GetHotelByPId(result.areaId).then(res => {
                                if (res.success) {
                                    var arry = [];
                                    res.result.map((item, index) => {
                                        arry.push({ label: item.name, value: item.id })
                                    })

                                    var item2 = arry.filter(x => x.value == result.cemeteryId);
                                    that.setState({
                                        valuePickerGM: item2[0] == null ? 0 : item2[0].value,
                                        textPickerGM: item2[0] == null ? 0 : item2[0].label
                                    })

                                }
                            })
                        }

                    }, 1000);

                    var list = [{
                        key: 999,
                        url: environment.apiEndpoint + "/NNFiles/Img/" + result.headImg,
                        thumbnailUrl: environment.apiEndpoint + "/NNFiles/Img/" + result.headImg,
                    }]
                    that.setState({
                        id: id,
                        imgName: result.headImg,
                        fileList: list,
                        textJG: res.result.hometown == null ? "请选择" : res.result.hometown,
                        planetInfo: result,
                    })
                }
            })
        }


        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

    }

    submitForm = () => {
        var that = this;

        // 如果正在加载中，直接返回，避免重复提交
        if (this.state.loading) {
            Toast.show({ icon: 'fail', content: '请勿重复提交！' });
            return;
        }

        this.formRef.current.validateFields()
            .then(values => {
                if (values.Birthday != undefined) {
                    values.Birthday = dayjs(values.Birthday).format("YYYY-MM-DD");
                }
                if (values.DeadDate != undefined) {
                    values.DeadDate = dayjs(values.DeadDate).format("YYYY-MM-DD");
                }
                
                const submitData = {
                    ...that.state.planetInfo,
                    ...values,
                    HeadImg: this.state.imgName,
                    BeliefId: this.state.valuePickerXY,
                    AreaId: this.state.valuePickerDQ,
                    CemeteryId: (this.state.valuePickerGM == 0 || this.state.valuePickerGM == "0")
                        ? null : this.state.valuePickerGM,
                    Hometown: this.state.textJG,
                };

                this.setState({ loading: true });
                SavePlanetInfo(submitData).then(res => {
                    if (res.success) {
                        Toast.show({ icon: 'success', content: '提交成功！' });
                        setTimeout(() => {
                            that.props.navigate('/formView', { replace: true, state: { id: this.state.id } });
                        }, 2000);
                    } else {
                        this.setState({ loading: false });
                    }

                })
            })
            .catch(error => {
                if (error.errorFields) {
                    Toast.show({ icon: 'fail', content: '请检查表单' });
                } else {
                    Toast.show({ icon: 'fail', content: error.message || '提交失败' });
                }
            });

    }
    


    render() {
        const { fileList, cropVisible, imageUrl } = this.state;

        return (
            <div style={{ backgroundColor: "rgb(227 227 227)", height: "100%" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/home?planetId=' + this.state.id, { replace: true, state: { id: this.state.id } }); // 传递状态
                }} style={{backgroundColor:"#fff"}}>
                    编辑资料
                </NavBar>

                <div className="formEdit" style={{
                    width: "90%", marginLeft: "5%", paddingTop: "10px", backgroundColor: "#fff", overflowY: "scroll"
                    , borderRadius: "10px", marginTop: "10px", height: "82%"
                }}>
                    <Form
                        name='form'
                        ref={this.formRef}
                        layout='horizontal'
                        footer={
                            <div>
                                <div style={{
                                    backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                    , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                    , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                    , fontWeight: "600", color: "#fff"
                                }} onClick={() => {
                                    this.submitForm();
                                }}>
                                    保 存
                                </div>
                            </div>
                        }
                    >

                        <div style={{ marginTop: "10px" }}>
                            <Grid columns={3} gap={8}>
                                <Grid.Item span={1}>
                                    <div style={{
                                        marginLeft: "25%", lineHeight: "60px", fontSize: "0.373333rem",
                                        fontWeight: "600", color: "var(--adm-color-text-secondary)",
                                    }}>
                                        头像
                                    </div>
                                </Grid.Item>
                                <Grid.Item span={2}>





                                    {/* 图片上传组件 */}
                                    <ImageUploader
                                        columns={3}
                                        maxCount={1}
                                        style={{ '--cell-size': '40px' }}
                                        value={fileList || []}
                                        beforeUpload={async (file) => {
                                            console.log('BeforeUpload - 文件信息:', file);
                                            if (!(file instanceof File)) {
                                                Toast.show({ icon: 'fail', content: '无效的文件！' });
                                                return false;
                                            }
                                            if (file.size > 5 * 1024 * 1024) {
                                                Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                                return false;
                                            }

                                            var res = await GetSystemMemorys(this.state.id);
                                            if (res.success) {
                                                var count = 0;
                                                res.result.map(item => {
                                                    count += item.fileSize;
                                                })
                                                var maxSize = 300;
                                                var models = this.state.userInfo.planetSizes
                                                    .filter(x => x.planetId == this.state.id);
                                                if (models != null && models.length > 0) {
                                                    maxSize = models[0].fileSumSize;
                                                }
                                                if (count > maxSize) {
                                                    Toast.show({ content: '该星球文件空间已满！' });
                                                    return false;
                                                }
                                            }


                                            // const fileCopy = new File([file], file.name, { type: file.type });
                                            // return fileCopy;

                                            // 清理旧的临时URL
                                            if (this.state.imageUrl) {
                                                URL.revokeObjectURL(this.state.imageUrl);
                                            }

                                            // 创建新的临时URL并打开裁剪弹窗
                                            const tempUrl = URL.createObjectURL(file);
                                            this.setState({
                                                imageUrl: tempUrl,
                                                pendingFile: file,
                                                cropVisible: true,
                                            });

                                            return false; // 阻止默认上传
                                        }}
                                        onChange={(fileList) => {
                                            this.setState({ fileList });
                                        }}
                                        upload={() => Promise.resolve({ url: '' })}
                                        deleteIcon={
                                            <Image src={"https://api.weibinyi.com/images/niannian/4/40-13.png"} fit='fill'
                                                width={14} height={14} />
                                        }
                                        children={
                                            <Image src={"https://api.weibinyi.com/images/niannian/4/2-12.png"} fit='fill'
                                                width={40} height={40} />
                                        }
                                    />

                                    {/* 裁剪弹窗 */}
                                    <Popup
                                        visible={cropVisible}
                                        onClose={() => {
                                            if (this.state.imageUrl) {
                                                URL.revokeObjectURL(this.state.imageUrl);
                                            }
                                            this.setState({
                                                cropVisible: false,
                                                imageUrl: null,
                                                pendingFile: null,
                                            });
                                        }}
                                        bodyStyle={{ padding: 0, height: '85vh' }}
                                        maskClosable={true} // 关键：允许点击遮罩层关闭弹窗
                                        mask={true} // 确保遮罩层存在（默认数库默认true，但显式声明置更保险）
                                    >
                                        {imageUrl && <ImageCropper imageUrl={imageUrl}
                                            onCropComplete={this.handleCropComplete}
                                            handleClose={() => {
                                                this.setState({
                                                    cropVisible: false,
                                                    imageUrl: null,
                                                    pendingFile: null,
                                                });
                                            }} />}
                                    </Popup>



                                    {/* <ImageUploader
                                        columns={3}
                                        maxCount={1}
                                        style={{ '--cell-size': '40px' }}
                                        value={this.state.fileList || []}
                                        defaultValue={this.state.fileList || []}
                                        beforeUpload={async (file) => {
                                            console.log('BeforeUpload - 文件信息:', file);
                                            if (!(file instanceof File)) {
                                                Toast.show({ icon: 'fail', content: '无效的文件！' });
                                                return false;
                                            }
                                            if (file.size > 5 * 1024 * 1024) {
                                                Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                                return false;
                                            }

                                            var res = await GetSystemMemorys(this.state.id);
                                            if (res.success) {
                                                var count = 0;
                                                res.result.map(item => {
                                                    count += item.fileSize;
                                                })
                                                var maxSize = 300;
                                                var models = this.state.userInfo.planetSizes
                                                    .filter(x => x.planetId == this.state.id);
                                                if (models != null && models.length > 0) {
                                                    maxSize = models[0].fileSumSize;
                                                }
                                                if (count > maxSize) {
                                                    Toast.show({ content: '该星球文件空间已满！' });
                                                    return false;
                                                }
                                            }
                                            const fileCopy = new File([file], file.name, { type: file.type });
                                            return fileCopy;
                                        }}
                                        onChange={(fileList) => {
                                            console.log('OnChange - 文件列表:', fileList);
                                            this.setState({ fileList });
                                        }}
                                        upload={async (file) => {
                                            try {
                                                console.log('Upload - 开始上传:', file);

                                                // 1. 验证文件对象
                                                if (!(file instanceof File)) {
                                                    throw new Error('无效的文件对象');
                                                }

                                                // 2. 创建临时预览URL
                                                const tempUrl = URL.createObjectURL(file);
                                                console.log('临时预览URL创建成功:', tempUrl);

                                                // 3. 上传文件
                                                const formData = new FormData();
                                                formData.append('file', file);
                                                formData.append('userid', this.state.userInfo.id);
                                                formData.append('scoureName', "Img");
                                                formData.append('planetId', this.state.id);

                                                const response = await SaveNNFile(formData);
                                                console.log('上传响应:', response);

                                                // 4. 确保返回正确的URL格式
                                                let imageUrl;
                                                if (typeof response === 'string') {
                                                    imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                                } else if (response.result) {
                                                    imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                                } else {
                                                    throw new Error('无效的服务器响应');
                                                }

                                                this.setState({
                                                    imgName: response.result
                                                })
                                                // 5. 释放临时URL
                                                URL.revokeObjectURL(tempUrl);

                                                return {
                                                    url: imageUrl
                                                };
                                            } catch (error) {
                                                console.error('上传过程出错:', error);
                                                Toast.show({ icon: 'fail', content: '上传失败' });
                                                throw error;
                                            }
                                        }}
                                        deleteIcon={
                                            <Image src={"https://api.weibinyi.com/images/niannian/4/40-13.png"} fit='fill'
                                                width={14} height={14} />
                                        }
                                        children={
                                            <Image src={"https://api.weibinyi.com/images/niannian/4/2-12.png"} fit='fill'
                                                width={40} height={40} />
                                        }
                                    /> */}
                                </Grid.Item>
                            </Grid>

                        </div>

                        {/* <Form.Item
                            name='HeadImg'
                            label='头像'
                        >
                            <ImageUploader
                                columns={3}
                                maxCount={1}
                                style={{ '--cell-size': '40px' }}
                                defaultValue={this.state.fileList}
                                onChange={(file) => {
                                    this.setState({
                                        fileList: file
                                    })
                                }}
                                upload={(file) => {
                                    return {
                                        url: URL.createObjectURL(file),
                                    }
                                }}
                                children={
                                    <Image src={"https://api.weibinyi.com/images/niannian/4/2-12.png"} fit='fill'
                                        width={40} height={40} />
                                }
                            />
                        </Form.Item> */}

                        <Form.Item
                            name='Name'
                            label='姓名'
                            rules={[{ required: true, message: '请输入相关内容' }]}
                        >
                            <Input onChange={console.log} placeholder='请输入相关内容' />
                        </Form.Item>

                        <Form.Item name='Sex' label='性别' required>
                            <Radio.Group>
                                <Space direction='horizontal'>
                                    <Radio value={true}>女</Radio>
                                    <Radio value={false}>男</Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>


                        <Form.Item
                            name='Ethnicity'
                            label='民族'
                        >
                            <Input onChange={console.log} placeholder='请输入民族' />
                        </Form.Item>

                        <Form.Item
                            name='Hometown' className="xinyang1"
                            label='籍贯'
                        >
                            <div onClick={async () => {
                                var options = this.state.options;
                                const value = await Cascader.prompt({
                                    options,
                                    title: '选择籍贯',
                                })
                                this.setState({
                                    textJG: (value == null || value == undefined || value.length == 0)
                                        ? "请选择" : value.join('-')
                                })
                            }} style={{
                                display: "flex",
                                alignItems: "center", // 垂直居中
                                justifyContent: "flex-end", // 内容右对齐
                            }}>
                                <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                    {this.state.textJG}
                                </span>
                                <span style={{ float: "right" }}>
                                    <RightOutline style={{ fontSize: "20px", color: "#d7d7d7" }} />
                                </span>
                            </div>
                        </Form.Item>

                        <Form.Item className="xinyang1" name='BeliefId' label="信仰">
                            <div onClick={() => {
                                this.setState({
                                    visibleXY: true
                                })
                            }} style={{
                                display: "flex",
                                alignItems: "center", // 垂直居中
                                justifyContent: "flex-end", // 内容右对齐
                            }}>
                                <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                    {this.state.textPickerXY}
                                </span>
                                <span style={{ float: "right" }}>
                                    <RightOutline style={{ fontSize: "20px", color: "#d7d7d7" }} />
                                </span>
                            </div>

                            <Picker
                                columns={this.state.pickerXY}
                                visible={this.state.visibleXY}
                                onClose={() => {
                                    this.setState({
                                        visibleXY: false
                                    })
                                }}
                                value={[this.state.valuePickerXY]}
                                onConfirm={(v) => {
                                    var value = v[0];
                                    var item = this.state.pickerXY[0].filter(x => x.value == value)
                                    this.setState({
                                        valuePickerXY: value,
                                        textPickerXY: item[0].label
                                    })
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            name='Hobby'
                            label='喜好'
                        >
                            <Input onChange={console.log} placeholder='请输入喜好' />
                        </Form.Item>


                        <Form.Item
                            name='Career'
                            label='职业'
                        >
                            <Input onChange={console.log} placeholder='请输入职业' />
                        </Form.Item>


                        <Form.Item
                            name='Birthday'
                            label='出生日期'
                            trigger='onConfirm'
                            onClick={(e, datePickerRef) => {
                                datePickerRef.current.open()
                            }}
                        >
                            <DatePicker
                                min={new Date(1900, 0, 1)}
                                max={new Date()}>
                                {value =>
                                    value ? dayjs(value).format('YYYY-MM-DD') : '请选择日期'
                                }
                            </DatePicker>
                        </Form.Item>

                        <Form.Item
                            name='DeadDate'
                            label='逝世日期'
                            trigger='onConfirm'
                            onClick={(e, datePickerRef) => {
                                datePickerRef.current.open()
                            }}
                        >
                            <DatePicker
                                min={new Date(1900, 0, 1)}
                                max={new Date()}>
                                {value =>
                                    value ? dayjs(value).format('YYYY-MM-DD') : '请选择日期'
                                }
                            </DatePicker>
                        </Form.Item>

                        <Form.Item className="formContent" name='Remark' label='简介' help='请输入简介'>
                            <TextArea
                                placeholder='请输入简介'
                                maxLength={100}
                                rows={5}
                                showCount
                            />
                        </Form.Item>


                        <Form.Item name='IsBuried' label='墓地'>
                            <Radio.Group>
                                <Space>
                                    <Radio value={true}>有</Radio>
                                    <Radio value={false}>无</Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item shouldUpdate noStyle>
                            {() => {
                                const form = this.formRef.current;
                                if (!form) return null;

                                const isBuried = form.getFieldValue('IsBuried');
                                if (isBuried) {
                                    return (
                                        <Form.Item className="xinyang1" name='AreaId' label="安葬区域">
                                            <div onClick={() => {
                                                this.setState({
                                                    visibleDQ: true
                                                })
                                            }} style={{
                                                display: "flex",
                                                alignItems: "center", // 垂直居中
                                                justifyContent: "flex-end", // 内容右对齐
                                            }}>
                                                <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                                    {this.state.textPickerDQ}
                                                </span>
                                                <span style={{ float: "right" }}>
                                                    <RightOutline style={{ fontSize: "20px", color: "#d7d7d7" }} />
                                                </span>
                                            </div>

                                            <Picker
                                                columns={this.state.pickerDQ}
                                                visible={this.state.visibleDQ}
                                                onClose={() => {
                                                    this.setState({
                                                        visibleDQ: false
                                                    })
                                                }}
                                                value={[this.state.valuePickerDQ]}
                                                onConfirm={(v) => {
                                                    var that = this;
                                                    var value = v[0];
                                                    var item = this.state.pickerDQ[0].filter(x => x.value == value)
                                                    this.setState({
                                                        valuePickerDQ: value,
                                                        textPickerDQ: item[0].label,
                                                        valuePickerGM: null,
                                                        textPickerGM: "请选择"
                                                    })

                                                    GetHotelByPId(value).then(res => {
                                                        if (res.success) {
                                                            var arry = [];
                                                            res.result.map((item, index) => {
                                                                arry.push({ label: item.name, value: item.id })
                                                            })
                                                            that.setState({
                                                                pickerGM: [arry]
                                                            })
                                                        }
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                    );
                                }
                                return null;
                            }}
                        </Form.Item>
                        
                        {/* <Form.Item shouldUpdate noStyle>
                            {() => {
                                const form = this.formRef.current;
                                if (!form) return null;

                                const isBuried = form.getFieldValue('IsBuried');
                                if (isBuried === '1') {
                                    return (
                                        <Form.Item className="xinyang1" name='22222' label="公墓区域">
                                            <div onClick={() => {
                                                this.setState({
                                                    visible: true
                                                })
                                            }} style={{
                                                display: "flex",
                                                alignItems: "center", // 垂直居中
                                                justifyContent: "flex-end", // 内容右对齐
                                            }}>
                                                <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                                    {this.state.textPicker}
                                                </span>
                                                <span style={{ float: "right" }}>
                                                    <RightOutline style={{ fontSize: "20px", color: "#d7d7d7" }} />
                                                </span>
                                            </div>

                                            <Picker
                                                columns={this.state.pickers}
                                                visible={this.state.visible}
                                                onClose={() => {
                                                    this.setState({
                                                        visible: false
                                                    })
                                                }}
                                                value={[this.state.valuePicker]}
                                                onConfirm={(v) => {
                                                    var value = v[0];
                                                    var item = this.state.pickers[0].filter(x => x.value == value)
                                                    this.setState({
                                                        valuePicker: value,
                                                        textPicker: item[0].label
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                    );
                                }
                                return null;
                            }}
                        </Form.Item> */}
                        <Form.Item shouldUpdate noStyle>
                            {() => {
                                const form = this.formRef.current;
                                if (!form) return null;

                                const isBuried = form.getFieldValue('IsBuried');
                                if (isBuried) {
                                    return (
                                        <Form.Item className="xinyang1" name='CemeteryId' label="墓园">
                                            <div onClick={() => {
                                                this.setState({
                                                    visibleGM: true
                                                })
                                            }} style={{
                                                display: "flex",
                                                alignItems: "center", // 垂直居中
                                                justifyContent: "flex-end", // 内容右对齐
                                            }}>
                                                <span style={{ fontSize: "15px", textAlign: "right", marginRight: "10px" }}>
                                                    {this.state.textPickerGM}
                                                </span>
                                                <span style={{ float: "right" }}>
                                                    <RightOutline style={{ fontSize: "20px", color: "#d7d7d7" }} />
                                                </span>
                                            </div>

                                            <Picker
                                                columns={this.state.pickerGM}
                                                visible={this.state.visibleGM}
                                                onClose={() => {
                                                    this.setState({
                                                        visibleGM: false
                                                    })
                                                }}
                                                value={[this.state.valuePickerGM]}
                                                onConfirm={(v) => {
                                                    if (v == null || v.length == 0 || v[0] == null) {
                                                        return true;
                                                    }
                                                    var value = v[0];
                                                    var item = this.state.pickerGM[0].filter(x => x.value == value)
                                                    this.setState({
                                                        valuePickerGM: value,
                                                        textPickerGM: item[0].label
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                    );
                                }
                                return null;
                            }}
                        </Form.Item>
                        <Form.Item shouldUpdate noStyle>
                            {() => {
                                const form = this.formRef.current;
                                if (!form) return null;

                                const isBuried = form.getFieldValue('IsBuried');
                                if (isBuried) {
                                    return (
                                        <Form.Item name="additionalField" name='CemeteryNum' label="墓穴号">
                                            <Input placeholder="请输入墓穴号" />
                                        </Form.Item>
                                    );
                                }
                                return null;
                            }}
                        </Form.Item>

                        {/* <Form.Item className="tuan" label='亲友团'>
                            <Space style={{ alignItems: "center" }}>
                                <Image
                                    src={"https://images.unsplash.com/photo-1567945716310-4745a6b7844b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=60"}
                                    width={30}
                                    height={30}
                                    fit='cover'
                                    style={{ borderRadius: 32 }}
                                />
                                <Image
                                    src={"https://images.unsplash.com/photo-1567945716310-4745a6b7844b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=60"}
                                    width={30}
                                    height={30}
                                    fit='cover'
                                    style={{ borderRadius: 32 }}
                                />
                                <Image
                                    src={"https://images.unsplash.com/photo-1567945716310-4745a6b7844b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=60"}
                                    width={30}
                                    height={30}
                                    fit='cover'
                                    style={{ borderRadius: 32 }}
                                />
                                <div
                                    style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: 32,
                                        backgroundColor: "rgb(187 187 187)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: 12,
                                        fontWeight: "bold",
                                        color: "rgb(68 68 68)"
                                    }}
                                >
                                    +10
                                            </div>
                            </Space>
                        </Form.Item> */}



                    </Form>

                </div>


                <BottomMenu  position="fixed" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);